import { Directive } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { forEach } from 'lodash';

@Directive({
    selector: '[laDocumentBuilderPage]',
    standalone: false
})
export class DocumentBuilderPageDirective {
  pageId!: string;

  formGroup = new FormGroup({});

  addControl(name: string, control: AbstractControl) {
    this.formGroup.addControl(name, control);
  }

  addControls(controls: Record<string, AbstractControl>) {
    forEach(controls, (control, name) => {
      this.addControl(name, control);
    });
  }
}
